import { Link } from "react-router-dom";

const stats = [
  { value: "20+", label: "收录影视作品" },
  { value: "14", label: "覆盖题材类型" },
  { value: "6", label: "主要出品地区" },
  { value: "每日", label: "内容持续更新" },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-primary-800 mt-14 md:mt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-white">
            关于星辰影视
          </h2>
          <p className="mt-4 text-sm md:text-base text-primary-100/90 leading-relaxed">
            星辰影视是一个面向影视爱好者的内容展示平台，汇聚电影与电视剧的名称、类型、地区、年份、评分与剧情简介等信息，帮助你快速浏览、筛选并了解感兴趣的作品。
          </p>
          <p className="mt-3 text-sm text-primary-200/80 leading-relaxed">
            我们持续整理热门与最新影视内容，提供分类浏览、关键词检索与同类推荐，让每一次打开都更接近你想看的那一部。
          </p>
          <div className="mt-6 flex items-center gap-3 flex-wrap">
            <Link
              to="/category?type=movie"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              开始浏览影视
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-primary-500 text-primary-100 hover:bg-primary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="rounded-lg bg-primary-700/60 p-5 border border-primary-600">
              <p className="font-heading font-black text-2xl md:text-3xl text-accent-300 font-label">
                {stat.value}
              </p>
              <p className="mt-1.5 text-xs md:text-sm text-primary-100/85">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}